// customization:
// 1° riga
// 1° colonna hardcoded con loghi
// 2° colonna --> prende dati da prima colonna delle footer columns configurate da pannello di controllo
// 3° colonna --> prende i social dal pannello di controllo social (toglierli dal footer small) + sotto hardcordare il loghetto come in fondo qui https://www.reggioemiliawelcome.it/it?set_language=it
// 2° riga --> riprende il map delle colonne footer del pannello di controllo

import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Grid } from 'semantic-ui-react';

import isEmpty from 'lodash/isEmpty';
import { flattenHTMLToAppURL } from '@plone/volto/helpers/Url/Url';
import { UniversalLink, ConditionalLink } from '@plone/volto/components';

import { getEditableFooterColumns, getItemsByPath } from 'volto-editablefooter';
import { SocialLinks } from 'volto-social-settings';

import config from '@plone/registry';
import emilia from 'iovisit-reggioemiliawelcome/components/Logos/emilia.svg';
import comune from 'iovisit-reggioemiliawelcome/components/Logos/logo-comune.svg';
import turismo from 'iovisit-reggioemiliawelcome/components/Logos/logo-emiliaromagnaturismo-it.svg';
import logo from 'iovisit-reggioemiliawelcome/components/Logos/logo-footer.png';

const messages = defineMessages({
  goToPage: {
    id: 'Vai alla pagina',
    defaultMessage: 'Vai alla pagina',
  },
  seguici_anche_su: {
    id: 'seguici_anche_su',
    defaultMessage: 'Seguici anche su',
  },
  use_brand: {
    id: 'use_brand',
    defaultMessage: "Ottieni l'utilizzo del marchio Reggio Emilia Welcome",
  },
});

const FooterMain = () => {
  const intl = useIntl();
  const location = useLocation();
  const dispatch = useDispatch();

  const footerConfiguration = useSelector(
    (state) => state.editableFooterColumns?.result,
  );

  useEffect(() => {
    dispatch(getEditableFooterColumns());
  }, [dispatch, location]);

  //filter rootpaths
  const footerColumns = getItemsByPath(
    footerConfiguration,
    location?.pathname?.length ? location.pathname : '/',
  );

  const iatrColumn = footerColumns[0];

  const Image = config.getComponent({ name: 'Image' }).component;

  return (
    <div className="iv--footer-main" id="footer">
      <Container>
        <div className="iv--logo"></div>

        <Grid stackable verticalAlign="top">
          <Grid.Row>
            <Grid.Column
              width={4}
              className="iv--footer-column iv--footer-column-menu"
            >
              <div className="additional-logos">
                <UniversalLink
                  href="https://www.comune.reggioemilia.it/"
                  overrideSpecialMark
                >
                  <Image src={comune} className="additional-logo" />
                </UniversalLink>
                <UniversalLink
                  href="https://www.visitemilia.com/"
                  overrideSpecialMark
                >
                  <Image src={emilia} className="additional-logo" />
                </UniversalLink>
                <UniversalLink
                  href="https://emiliaromagnaturismo.it/it"
                  overrideSpecialMark
                >
                  <Image src={turismo} className="additional-logo" />
                </UniversalLink>
              </div>
            </Grid.Column>
            <Grid.Column
              width={4}
              className="iv--footer-column iv--footer-column-menu"
            >
              {!isEmpty(iatrColumn) && iatrColumn?.text?.data && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: flattenHTMLToAppURL(iatrColumn.text.data),
                  }}
                />
              )}
            </Grid.Column>

            <Grid.Column
              width={4}
              className="iv--footer-column iv--footer-column-menu logo-footer"
            >
              <h4>{intl.formatMessage(messages.seguici_anche_su)}</h4>
              <SocialLinks />

              <Image src={logo} className="logo-footer" />

              <div className="brand">
                <UniversalLink href="/it/richiedi-lutilizzo-del-marchio-reggio-emilia-welcome">
                  {intl.formatMessage(messages.use_brand)}
                </UniversalLink>
              </div>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            {footerColumns.slice(1)?.map((column, i) => (
              <Grid.Column width={4} className="iv--footer-column" key={i}>
                <h4>
                  {column?.title &&
                    (column?.titleLink?.length > 0 ? (
                      <ConditionalLink
                        condition={column.titleLink?.length > 0}
                        item={column.titleLink?.[0]}
                        to={column.titleLink?.[0]?.['@id'] ? null : ''}
                        title={
                          intl.formatMessage(messages.goToPage) +
                          ':' +
                          column.title
                        }
                      >
                        {column.title}
                      </ConditionalLink>
                    ) : (
                      column.title
                    ))}
                </h4>

                {column?.text?.data && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: flattenHTMLToAppURL(column.text.data),
                    }}
                  />
                )}
              </Grid.Column>
            ))}
          </Grid.Row>
        </Grid>
      </Container>
    </div>
  );
};

export default FooterMain;
